const api = jQuery.Zend.jsonrpc({url:'/_api.php', async:true});

const setupComments = () => {
	$('.add-new-comment').click(function() {
		var val = $('input[name="add-comment-content"]').val().trim();
		
		if (!val || val == '') {
			alert('Wpisz treść komentarza!');
			return false;
		}
		
		var item_id = $('input[name="add-comment-content"]').data('id');
		if (!item_id) {
			return false;
		}
		
		var item_module = $('input[name="add-comment-content"]').data('module');
		if (!item_module) {
			return false;
		}
		
		var element = $(this);
		
		var parent_id = element.closest('.add-comment').data('id');
		if (!parent_id) {
			parent_id = null;
		}
		
		api.addNewComment(val, item_module, item_id, parent_id, {
			success: function(r) {
				if (r) {
					// add comment
					var parent = element.closest('.add-comment').prev();
					parent.after(r);
					
					// reset input
					$('input[name="add-comment-content"]').val('');
					
					// setup likes
					setupCommentLike();
				}
			},
			error: function(r) {
				console.log('error');
				console.log(r);
			}
		});
		
		return false;
	});
}

const setupNewComment = () => {
	$('.add-comment-input').click(function() {
		var parent = $(this).closest('.comment');
		
		if ($('.add-comment-to-' + parent.data('id')).length > 0) {
			return false;
		}
		
		var input = $('#add-comment-input').html();
					
		var newElement = window.document.createElement('div');
		newElement.className = 'add-comment add-comment-to-'+parent.data('id')+' comment--inner';
		newElement.setAttribute('data-id', parent.data('id'));
		newElement.innerHTML = input;
		newElement.style.marginBottom = '20px';
				
		parent.after(newElement);

		$('.add-comment-to-' + parent.data('id') + ' .add-comment-content').val("@" + $(this).data('answerto') + ': ');
		
		setupComments();
		
		return false;
	});
}

const setupCommentLike = () => {
	$('.comment-like').click(function() {
		var element = $(this);
		var currentLikes = parseInt($('.num', element).html());
		
		api.likeComment(element.data('commentid'), {
			success: function(r) {				
				if (r) {
					currentLikes++;
					$('.num', element).html(currentLikes);
				}
			}
		})	
	});
}

const userGameFavorite = () => {
	$('.user-game-favorite-button').click(function() {
		api.gameFavorite($(this).data('id'), {
			success: function(r) {
				if (r.resp) {
					$('.user-game-favorite-button').html(r.message);
					
					if (r.action == 'add') {
						$('.user-game-favorite-status').addClass('icon-heart-on');
					} else if (r.action == 'remove') {
						$('.user-game-favorite-status').removeClass('icon-heart-on');
					}
				}	
			}
		})
		
		return false;
	});
} 

module.exports = {
	api,
    setupComments,
	setupNewComment,
	setupCommentLike,
	userGameFavorite
};